<app-admin-page-shell
  titleKey="app.admin.audience.title"
  subtitleKey="app.admin.audience.subtitle"
  [panelled]="false"
>
  <div class="audience">
    <div class="audience__top">
      <section class="audience-panel" aria-labelledby="audience-contacts-heading">
        <header class="audience-panel__header">
          <div class="audience-panel__header-row">
            <h2 id="audience-contacts-heading" class="audience-panel__title">
              {{ 'app.admin.audience.contactsTitle' | translate }}
            </h2>
            <app-cta-button
              class="audience-refresh-btn"
              variant="round"
              size="small"
              [loading]="loadingContacts()"
              [disabled]="busy() || loadingContacts()"
              [attr.aria-label]="'app.admin.audience.refresh' | translate"
              (clicked)="loadContacts()"
            >
              <img
                cta-prefix
                src="/public/svgs/refresh.svg"
                alt=""
                aria-hidden="true"
              />
            </app-cta-button>
          </div>
          <p class="audience-panel__hint">
            {{ 'app.admin.audience.contactsHint' | translate }}
          </p>
        </header>

        <div
          class="audience-tags"
          role="listbox"
          [attr.aria-label]="'app.admin.audience.filterTag' | translate"
        >
          @for (tag of tags; track tag) {
            <app-cta-button
              class="audience-tag"
              [class.audience-tag--active]="filterTag() === tag"
              [variant]="filterTag() === tag ? 'normal' : 'plain'"
              size="small"
              role="option"
              [attr.aria-selected]="filterTag() === tag"
              (clicked)="onFilterTagChange(tag)"
            >
              <span cta-label>{{ tag }}</span>
            </app-cta-button>
          }
        </div>

        <div class="audience-count-card">
          @if (loadingContacts()) {
            <mat-spinner diameter="28"></mat-spinner>
          } @else {
            <span class="audience-count-card__value">{{ contactsTotal() | number }}</span>
            <span class="audience-count-card__label">
              {{ 'app.admin.audience.contactsInTag' | translate: { tag: filterTag() } }}
            </span>
          }
        </div>

        <div class="audience-fields">
          <h3 class="audience-fields__title">
            {{ 'app.admin.audience.addContact' | translate }}
          </h3>
          <div class="audience-fields__row">
            <label class="audience-field">
              <span>{{ 'app.admin.audience.email' | translate }}</span>
              <input
                type="email"
                [(ngModel)]="upsertEmail"
                [placeholder]="'app.admin.audience.emailPlaceholder' | translate"
              />
            </label>
            <label class="audience-field">
              <span>{{ 'app.admin.audience.contactName' | translate }}</span>
              <input
                type="text"
                [(ngModel)]="upsertName"
                [placeholder]="'app.admin.audience.contactNamePlaceholder' | translate"
              />
            </label>
          </div>
          <div class="audience-field audience-field--wide">
            <span>{{ 'app.admin.audience.contactTags' | translate }}</span>
            <div
              class="audience-tags audience-tags--select"
              role="group"
              [attr.aria-label]="'app.admin.audience.contactTags' | translate"
            >
              @for (tag of tags; track tag) {
                <app-cta-button
                  class="audience-tag"
                  [class.audience-tag--active]="isUpsertTagSelected(tag)"
                  [variant]="isUpsertTagSelected(tag) ? 'normal' : 'plain'"
                  size="small"
                  (clicked)="toggleUpsertTag(tag)"
                >
                  <span cta-label>{{ tag }}</span>
                </app-cta-button>
              }
              @for (tag of upsertCustomTags(); track tag) {
                <app-cta-button
                  class="audience-tag"
                  [class.audience-tag--active]="true"
                  variant="normal"
                  size="small"
                  (clicked)="toggleUpsertTag(tag)"
                >
                  <span cta-label>{{ tag }}</span>
                </app-cta-button>
              }
            </div>
            <div class="audience-custom-tag">
              <input
                type="text"
                [(ngModel)]="upsertCustomTag"
                [placeholder]="'app.admin.audience.customTagPlaceholder' | translate"
                (keydown)="onUpsertCustomTagKeydown($event)"
              />
              <app-cta-button
                size="small"
                variant="plain"
                (clicked)="addUpsertCustomTag()"
                [disabled]="busy()"
              >
                <span cta-label>{{ 'app.admin.audience.addCustomTag' | translate }}</span>
              </app-cta-button>
            </div>
            <p class="audience-field__hint">
              {{ 'app.admin.audience.contactTagsHint' | translate }}
            </p>
          </div>
          <div class="audience-fields__row">
            <app-cta-button
              size="small"
              (clicked)="upsertContact()"
              [disabled]="busy()"
            >
              <span cta-label>{{ 'app.admin.audience.saveContact' | translate }}</span>
            </app-cta-button>
          </div>
        </div>
      </section>

      <section class="audience-panel" aria-labelledby="audience-campaigns-heading">
        <header class="audience-panel__header">
          <div>
            <h2 id="audience-campaigns-heading" class="audience-panel__title">
              {{ 'app.admin.audience.campaignsTitle' | translate }}
            </h2>
            <p class="audience-panel__hint">
              {{ 'app.admin.audience.campaignsHint' | translate }}
            </p>
          </div>
        </header>

        <div class="audience-fields audience-fields--flush">
          <div class="audience-fields__grid">
            <label class="audience-field audience-field--wide">
              <span>{{ 'app.admin.audience.campaignName' | translate }}</span>
              <input
                type="text"
                [(ngModel)]="campaignName"
                [placeholder]="'app.admin.audience.campaignNamePlaceholder' | translate"
              />
            </label>
            <div class="audience-field audience-field--wide">
              <span>{{ 'app.admin.audience.campaignTags' | translate }}</span>
              <div
                class="audience-tags audience-tags--select"
                role="group"
                [attr.aria-label]="'app.admin.audience.campaignTags' | translate"
              >
                @for (tag of tags; track tag) {
                  <app-cta-button
                    class="audience-tag"
                    [class.audience-tag--active]="isCampaignTagSelected(tag)"
                    [variant]="isCampaignTagSelected(tag) ? 'normal' : 'plain'"
                    size="small"
                    (clicked)="toggleCampaignTag(tag)"
                  >
                    <span cta-label>{{ tag }}</span>
                  </app-cta-button>
                }
                @for (tag of campaignCustomTags(); track tag) {
                  <app-cta-button
                    class="audience-tag"
                    [class.audience-tag--active]="true"
                    variant="normal"
                    size="small"
                    (clicked)="toggleCampaignTag(tag)"
                  >
                    <span cta-label>{{ tag }}</span>
                  </app-cta-button>
                }
              </div>
              <div class="audience-custom-tag">
                <input
                  type="text"
                  [(ngModel)]="campaignCustomTag"
                  [placeholder]="'app.admin.audience.customTagPlaceholder' | translate"
                  (keydown)="onCampaignCustomTagKeydown($event)"
                />
                <app-cta-button
                  size="small"
                  variant="plain"
                  (clicked)="addCampaignCustomTag()"
                  [disabled]="busy()"
                >
                  <span cta-label>{{ 'app.admin.audience.addCustomTag' | translate }}</span>
                </app-cta-button>
              </div>
              <p class="audience-field__hint">
                {{ 'app.admin.audience.campaignTagsHint' | translate }}
              </p>
            </div>
            <label class="audience-field audience-field--wide">
              <span>{{ 'app.admin.audience.tagMatch' | translate }}</span>
              <select [(ngModel)]="campaignTagMatch">
                @for (option of campaignTagMatchOptions; track option.value) {
                  <option [ngValue]="option.value">
                    {{ option.labelKey | translate }}
                  </option>
                }
              </select>
              <p class="audience-field__hint">
                {{
                  (campaignTagMatch === 'all'
                    ? 'app.admin.audience.tagMatchAllHint'
                    : 'app.admin.audience.tagMatchAnyHint'
                  ) | translate
                }}
              </p>
            </label>
            <label class="audience-field audience-field--wide">
              <span>{{ 'app.admin.audience.fromDomain' | translate }}</span>
              <select [(ngModel)]="campaignFromDomain">
                @for (domain of fromDomains; track domain) {
                  <option [ngValue]="domain">{{ fromAddressFor(domain) }}</option>
                }
              </select>
              <p class="audience-field__hint">
                {{ 'app.admin.audience.fromDomainHint' | translate }}
              </p>
            </label>
            <label class="audience-field audience-field--wide">
              <span>{{ 'app.admin.audience.templateId' | translate }}</span>
              <select
                [(ngModel)]="campaignTemplateId"
                [disabled]="loadingTemplates() || templates().length === 0"
              >
                @if (loadingTemplates()) {
                  <option [ngValue]="null">
                    {{ 'app.admin.audience.templatesLoading' | translate }}
                  </option>
                } @else if (templates().length === 0) {
                  <option [ngValue]="null">
                    {{ 'app.admin.audience.templatesEmpty' | translate }}
                  </option>
                } @else {
                  @for (template of templates(); track template.templateId) {
                    <option [ngValue]="template.templateId">
                      {{ templateLabel(template) }}
                    </option>
                  }
                }
              </select>
              <p class="audience-field__hint">
                {{ 'app.admin.audience.templateNameHint' | translate }}
              </p>
            </label>
            <label class="audience-field">
              <span>{{ 'app.admin.audience.batchSize' | translate }}</span>
              <input
                type="number"
                min="1"
                max="500"
                [(ngModel)]="campaignBatchSize"
              />
            </label>
            <label class="audience-field">
              <span>{{ 'app.admin.audience.maxBatches' | translate }}</span>
              <input
                type="number"
                min="1"
                max="1000"
                [(ngModel)]="campaignMaxBatches"
              />
            </label>
          </div>
          <div class="audience-fields__footer">
            <label class="audience-check">
              <input type="checkbox" [(ngModel)]="campaignDryRun" />
              <span>{{ 'app.admin.audience.dryRun' | translate }}</span>
            </label>
            <app-cta-button
              size="small"
              (clicked)="createCampaign()"
              [disabled]="busy()"
            >
              <span cta-label>{{ 'app.admin.audience.createDraft' | translate }}</span>
            </app-cta-button>
          </div>
        </div>
      </section>
    </div>

    <section
      class="audience-panel audience-panel--list"
      aria-labelledby="audience-list-heading"
    >
      <header class="audience-panel__header">
        <div class="audience-panel__header-row">
          <h2 id="audience-list-heading" class="audience-panel__title">
            {{ 'app.admin.audience.campaignsListTitle' | translate }}
          </h2>
          <div class="audience-panel__actions">
            <label class="audience-filter">
              <span>{{ 'app.admin.audience.hideCompleted' | translate }}</span>
              <app-admin-toggle-switch
                [checked]="hideCompletedCampaigns()"
                [ariaLabel]="'app.admin.audience.hideCompleted' | translate"
                (checkedChange)="onHideCompletedChange($event)"
              />
            </label>
            <app-cta-button
              class="audience-refresh-btn"
              variant="round"
              size="small"
              [loading]="loadingCampaigns()"
              [disabled]="busy() || loadingCampaigns()"
              [attr.aria-label]="'app.admin.audience.refresh' | translate"
              (clicked)="loadCampaigns()"
            >
              <img
                cta-prefix
                src="/public/svgs/refresh.svg"
                alt=""
                aria-hidden="true"
              />
            </app-cta-button>
          </div>
        </div>
        <p class="audience-panel__hint">
          {{ 'app.admin.audience.campaignsListHint' | translate }}
        </p>
      </header>

      @if (loadingCampaigns()) {
        <div class="audience-loading">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      } @else if (campaigns().length === 0) {
        <p class="audience-empty">
          {{ 'app.admin.audience.noCampaigns' | translate }}
        </p>
      } @else if (visibleCampaigns().length === 0) {
        <p class="audience-empty">
          {{ 'app.admin.audience.noVisibleCampaigns' | translate }}
        </p>
      } @else {
        <ul class="audience-campaigns">
          @for (c of visibleCampaigns(); track c.id) {
            <li class="audience-campaign">
              <div class="audience-campaign__identity">
                <div class="audience-campaign__title-row">
                  <strong>
                    {{ c.name || ('app.admin.audience.untitledCampaign' | translate) }}
                  </strong>
                  <span class="audience-status" [attr.data-status]="c.status">
                    {{ c.status }}
                  </span>
                </div>
                <div class="audience-campaign__tags">
                  @for (tag of c.tags; track tag) {
                    <span class="audience-chip">{{ tag }}</span>
                  }
                  <span class="audience-chip audience-chip--muted">
                    {{ tagMatchLabel(c.tagMatch) }}
                  </span>
                  <span class="audience-chip audience-chip--muted">
                    {{ campaignFromAddress(c) }}
                  </span>
                  @if (c.dryRun) {
                    <span class="audience-chip audience-chip--muted">
                      {{ 'app.admin.audience.dryRunBadge' | translate }}
                    </span>
                  }
                </div>
              </div>

              <div class="audience-campaign__details">
                <dl class="audience-metrics">
                  <div>
                    <dt>{{ 'app.admin.audience.recipients' | translate }}</dt>
                    <dd>{{ c.totalRecipients | number }}</dd>
                  </div>
                  <div>
                    <dt>{{ 'app.admin.audience.remaining' | translate }}</dt>
                    <dd>{{ c.remainingCount | number }}</dd>
                  </div>
                  <div>
                    <dt>{{ 'app.admin.audience.sent' | translate }}</dt>
                    <dd>{{ c.sentCount | number }}</dd>
                  </div>
                  <div>
                    <dt>{{ 'app.admin.audience.failed' | translate }}</dt>
                    <dd>{{ c.failedCount | number }}</dd>
                  </div>
                </dl>

                <div class="audience-fields audience-fields--campaign-settings audience-fields--flush">
                  <div class="audience-fields__row">
                    <label class="audience-field audience-field--compact">
                      <span>{{ 'app.admin.audience.batchSize' | translate }}</span>
                      <input
                        type="number"
                        min="1"
                        max="500"
                        [(ngModel)]="c.batchSize"
                        [disabled]="busy() || !canEditSettings(c)"
                      />
                    </label>
                    <label class="audience-field audience-field--compact">
                      <span>{{ 'app.admin.audience.maxBatches' | translate }}</span>
                      <input
                        type="number"
                        min="1"
                        max="1000"
                        [(ngModel)]="c.maxBatches"
                        [disabled]="busy() || !canEditSettings(c)"
                      />
                    </label>
                    @if (canEditSettings(c)) {
                      <app-cta-button
                        size="small"
                        variant="plain"
                        (clicked)="updateCampaignSettings(c)"
                        [disabled]="busy()"
                      >
                        <span cta-label>{{ 'app.admin.audience.saveSettings' | translate }}</span>
                      </app-cta-button>
                    }
                  </div>
                </div>
              </div>

              <div class="audience-campaign__action">
                @if (canStart(c)) {
                  <app-cta-button
                    size="small"
                    (clicked)="startCampaign(c)"
                    [disabled]="busy()"
                  >
                    <span cta-label>{{ 'app.admin.audience.start' | translate }}</span>
                  </app-cta-button>
                }
                @if (canArchive(c)) {
                  <app-cta-button
                    size="small"
                    variant="plain"
                    (clicked)="archiveCampaign(c)"
                    [disabled]="busy()"
                  >
                    <span cta-label>{{ 'app.admin.audience.archive' | translate }}</span>
                  </app-cta-button>
                }
              </div>
            </li>
          }
        </ul>
      }
    </section>
  </div>
</app-admin-page-shell>
